export class MagickLinkHolded {
    /* http://localhost:4201/prescriptions/new;userCode=MOYA;professionalCode=MOY;clinicCode=46C07;patientCode=BDBR08505250;indi=LAS2,LAS8,0002, */
    userCode :                                      string = '';
    clinicCode :                                    string = '';
    professionalCode :                              string = '';
    holdingReasong :                                string = '';
    patientCode :                                   string = '';
    indi :                                          string = '';
    action:                                         string = 'initial';
}